
class FbdClassRosterPreview {
   rosterContainer;
   eGui;
   classId;

   init(params) {
      const roster = params.value;
      this.eGui = document.createElement("span");

      this.rosterContainer = document.createElement("div");

      if(typeof roster === "object" && roster !== null) {
         this.classId = params.data['class_id'];
         this.rosterContainer.classList.add("class-roster-preview");

         let idx = 0;
         for (const [st, vals] of Object.entries(roster)) {
            if(idx > 0) {
               const tn = document.createTextNode(', ');
               this.rosterContainer.appendChild(tn);

               if(idx === 3) {
                  const excTn = document.createTextNode(`${Object.keys(roster).length - 3} more...`);
                  this.rosterContainer.appendChild(excTn);
                  break;
               }
            }

            const lk = document.createElement('a');
            lk.innerText = ("student_name" in vals) ? vals['student_name'] : st;
            lk.href = `?class=${this.classId}#${encodeURIComponent(st)}`;

            this.rosterContainer.appendChild(lk);
            idx++;
         }
      }

      this.eGui.appendChild(this.rosterContainer);
   }

   getGui() {
      return this.eGui;
   }

   refresh(params) {
      return false;
   }

   destroy() {

   }
}

export default FbdClassRosterPreview;